import React from 'react';
import { Box, Row, Column, Grid } from './core';
import { FlexProps } from 'theme-ui';

const styles = {
  reset: {
    verticalAlign: 'baseline',
    border: 0,
    outline: 0,
    margin: 0,
    padding: 0,
  },
  row: {
    borderStyle: 'solid',
    borderWidth: '0px',
    borderTopWidth: '1px',
    borderColor: 'muted',
    pt: 2,
    pb: 2,
    rowGap: 2,
  },
  header: {
    display: 'block',
    letterSpacing: 'smallcaps',
    fontFamily: 'heading',
    fontSize: 2,
  },
  index: {
    display: 'block',
    letterSpacing: 'smallcaps',
    fontFamily: 'heading',
    fontSize: 2,
  },
  entry: {
    display: 'block',
    fontSize: 2,
    fontFamily: 'faux',
    letterSpacing: 'faux',
    mb: ['1px'],
  },
};

interface TableProps extends FlexProps {
  data: Array<[string | JSX.Element, string | JSX.Element]>;
  header?: string | Element;
  columns?: string | number | any[];
  index?: boolean;
  borderBottom?: boolean;
  borderTop?: boolean;
}

export const Table = ({
  data,
  sx,
  color,
  header,
  columns,
  index = true,
  borderBottom = true,
  borderTop = true,
  ...rest
}: TableProps): JSX.Element => {
  if (!columns) {
    throw new Error('Must provide columns');
  }
  return (
    <Box
      {...rest}
      as="table"
      sx={{ display: 'block', tableLayout: 'fixed', ...sx }}
    >
      <Box as="tbody" sx={{ display: 'block' }}>
        {header && (
          <Row
            as="tr"
            sx={{
              ...styles.reset,
              ...styles.header,
              ...styles.row,
              color: color,
              borderTopWidth: !borderTop ? '0px' : '1px',
            }}
          >
            <Column as="td" sx={styles.index}>
              {header}
            </Column>
          </Row>
        )}
        {data.map((row, i) => {
          return (
            <Grid
              as="tr"
              columns={columns}
              key={i}
              sx={{
                ...styles.reset,
                ...styles.row,
                borderBottomWidth:
                  borderBottom && i === data.length - 1 ? '1px' : '0px',
                borderTopWidth:
                  !borderTop && i === 0 && !header ? '0px' : '1px',
              }}
            >
              {row.map((column, j) => {
                return (
                  <Column
                    as="td"
                    key={j}
                    sx={
                      j == 0 && index
                        ? { ...styles.reset, ...styles.index }
                        : { ...styles.reset, ...styles.entry }
                    }
                  >
                    {column}
                  </Column>
                );
              })}
            </Grid>
          );
        })}
      </Box>
    </Box>
  );
};
